// extracted by mini-css-extract-plugin
export default {"logo_container":"LogoComponent_logo_container__e7z6r","logo_text":"LogoComponent_logo_text__Olwv6","logo_wrapper":"LogoComponent_logo_wrapper__9+nSC"};